import styled from "styled-components";

export const ConfirmationTabBody = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;    
`;

export const LoadingLabel = styled.div`
    color: rgba(172, 52, 33, 1);
    font-size: 1.2rem;
    font-weight: bold;
    margin: 2rem 0;
`;

export const ConfirmLabel = styled.div`
    color: #abbd81;
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0;
`;

export const LicencePriceWrapper = styled.div`
    text-align: center;
    font-size: 0.9rem;
`;

export const LicencePrice = styled.div`
    color: #abbd81;
    font-size: 1.4rem;
    font-weight: bold;
    margin: 1rem 0;
`;